import React, {
  useRef,
  useEffect,
  useCallback,
  useState,
  ChangeEvent,
} from 'react';
import { FormHandles } from '@unform/core';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
	Spinner,
} from '@chakra-ui/react';
import { FiCamera, FiX, FiMoreVertical } from 'react-icons/fi';
import * as Yup from 'yup';
import { search } from 'ss-search';
import { v4 as uuid } from 'uuid';
import Resizer from 'react-image-file-resizer';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { useProdutoHook } from '../../../hooks/produtohook';
import { useToast } from '../../../hooks/toast';
import { formatPrice } from '../../../utils/format';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Inputs/Input';
import InputSelectClassif from '../../Inputs/Selects/InputSelectClassif';
import InputTextArea from '../../Inputs/inputTextArea';
import InputCheckbox from '../../Inputs/InputCheckbox';

import {
  Container,
  Content,
  Header,
  TabsView,
  TabProduto,
  TabComplemento,
  FormViewDetalhes,
  ImgInput,
  Buttons,
  SelectedYesNo,
  ButtonsComp,
  GruposList,
  Grupo,
  ComplementosList,
  Complemento,
  AddGrupoComplementos,
  FormViewGrupoComp,
} from './styles';

type ProdutoData = {
  id: string;
  categoria: string;
  cod_barras: string;
  complementos: string;
  descricao: string;
  nome: string;
  promocao: string;
  qtd: number;
  status: string;
  total: number;
  valor: number;
  url_imagem: string;
  id_classif: number;
}
type ClassifsData = {
  id: number;
  sub_classif: string;
}
type GrupoData = {
  id: string;
  nome: string;
  obrigatorio: string;
  min_itens: number;
  max_itens: number;
  complementos: ComplementosData[];
}
type ComplementosData = {
  cod: string;
  nome: string;
  descricao: string;
  valor: number;
  qtd_gratis: number;
  qtd_maxima: number;
}
type FormProdutoPARAMS = {
  id: string;
  cod_barras: string;
  nome: string;
  classif: number;
  descricao: string;
  valor: string;
  imagem: any;
  url_imagem: string;
  grupos: GrupoData[];
  remove_azure: boolean;
  venda_delivery: boolean;
  venda_local: boolean;
  destaque_delivery: boolean;
  destaque_local: boolean;
  sku: string;
  ativo: string;
}
type ClassificacaoData = {
  id: number;
  id_sub: number;
  nome: string;
  prod_visible: boolean;
  status: string;
}
interface ModalParams {
	onClose: any;
	isVisible: boolean;
	product: ProdutoData;
	setModalGrupoCompVisible: any;
	setGrupoModal: any;
	produtos: ProdutoData[];
	classificacao: ClassificacaoData;
}

const ModalProduto: React.FC<ModalParams> = ({
  onClose = () => {},
  isVisible,
  product,
  setModalGrupoCompVisible,
  setGrupoModal,
  produtos,
  classificacao,
}) => {
  const formRef = useRef<FormHandles>(null);
  const formRefGrupoComp = useRef<FormHandles>(null);

  const { company, signOut } = useAuth();
  const {
    produto,
    setHookProduto,
    resetHookProduto,
    removeHookGrupo,
  } = useProdutoHook();
  const { addToast } = useToast();

  const [visible, setVisible] = useState(isVisible);

	const [loading, setLoading] = useState(true);

  const [classificacoes, setClassificacoes] = useState<ClassifsData[]>([]);
  const [fotoUrl, setFotoUrl] = useState<any>();
  const [img, setImg] = useState<any>(null);

  const [tabIndex, setTabIndex] = useState(0);
  const [descriptionLength, setDescriptionLength] = useState(0);

  const [radioComp, setRadioComp] = useState('N');
  // produto?.grupos?.length > 0 ? 'S' : 'N',);

  const [copyGroup, setCopyGroup] = useState(false);
  const [pesquisa, setPesquisa] = useState<any[]>([]);
  const [produtosVisibles, setProdutosVisibles] = useState(false);
  const [productSelect, setProdutoSelect] = useState<ProdutoData>(
    {} as ProdutoData,
  );

  const handleMoeda = useCallback(() => {
    let moedastr = formRef.current?.getFieldValue('valor');
    moedastr = moedastr.replace(/\D/g, '');

    if (moedastr) {
      const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));

      let tmp = `${moeda}`;
      tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
      if (tmp.length > 6)
        tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

      formRef.current?.setFieldValue('valor', `R$ ${tmp}`);
    } else {
      moedastr = moedastr.replace(/\D/g, '');
      formRef.current?.setFieldValue('valor', `${moedastr}`);
    }
  }, []);

	async function fetchProduto() {
		try {
			const { data } = await api.post('portal/produto/index', {
					emp: company.id,
					id: product?.id ? product.id : '0',
				})
				.catch(err => {
					throw err;
				});

			setClassificacoes(data.subclassificacao);

			if (product?.id) {
				setHookProduto(data.produto);

				setFotoUrl(
					data.produto.url_imagem
						? data.produto.url_imagem
						: null,
				);

				// formRef.current?.setFieldValue('classif', String(classificacao.id_sub));

				// para setar o input[type='radio'] de complementos conforme o produto
				data.produto.grupos?.length > 0
					? setRadioComp('S')
					: setRadioComp('N');

				formRef.current?.setFieldValue(
					'valor',
					formatPrice(data.produto.valor),
				);

				formRef.current?.setData(data.produto);
			} else {
				resetHookProduto();
			}
		}
		catch (error) {
			addToast({
				type: 'info',
				title: 'Produto',
				description:
					'Erro ao buscar dados do produto.',
			});
		}
		finally {
			setLoading(false);
		}
	}

  useEffect(() => {
    fetchProduto();
  }, [
    product,
    setHookProduto,
    handleMoeda,
    classificacao,
    company,
    signOut,
    addToast,
    resetHookProduto,
  ]);

  const resizeFile = useCallback((file: any) => {
    return new Promise(resolve => {
      Resizer.imageFileResizer(
        file,
        1920,
        1080,
        'JPEG',
        80,
        0,
        uri => {
          resolve(uri);
        },
        'file',
      );
    });
  }, []);

  const handleImagemChange = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];

        const size = parseFloat((file.size / 1024 / 1024).toFixed(1));

        // Se for maior que 4 megabytes
        if (size > 4) {
          alert('Tamanho da imagem superior ao permitido!');
          return;
        }

        if (product?.id) {
          const auxProduto = produto;
          auxProduto.remove_azure = auxProduto.url_imagem === '' ? false : true;
          setHookProduto(auxProduto);
        }

        if (size > 1) {
          const aux: any = await resizeFile(file);

          setImg(aux);
          setFotoUrl(URL.createObjectURL(aux));
        } else {
          setImg(event.target.files[0]);
          setFotoUrl(URL.createObjectURL(event.target.files[0]));
        }
      }

      // event.target.value = '';
    },
    [produto, setHookProduto, product, resizeFile],
  );

  const handleRemoveImg = useCallback(() => {
    if (!img) {
      if (product?.id) {
        const auxProduto = produto;
        auxProduto.remove_azure = true;
        setHookProduto(auxProduto);
      }
      // auxProduto.imagem = false;
      // setProduto(auxProduto);

      // return;
    }

    setImg(null);
    setFotoUrl(null);
  }, [product, img, produto, setHookProduto]);

  const handleDescriptionLength = useCallback(() => {
    const leng = formRef.current?.getFieldValue('descricao').length;
    setDescriptionLength(leng);
  }, []);

  const handleSubmit = useCallback(async (data: FormProdutoPARAMS) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          cod_barras: Yup.string().required('Código do item obrigatório'),
          sku: Yup.string().required('Código SKU obrigatório'),
          classif: Yup.number().required('Classificação do item obrigatório'),
          nome: Yup.string().required('Nome do item obrigatório'),
          descricao: Yup.string(),
          valor: Yup.string().required('Valor do item obrigatório'),
          remove_azure: Yup.boolean(),
          venda_delivery: Yup.boolean(),
          venda_local: Yup.boolean(),
          destaque_delivery: Yup.boolean(),
          destaque_local: Yup.boolean(),
        });

        await schema.validate(data, { abortEarly: false });

        let aux = data.valor.replace('R$', '');
        aux = aux.replace(' ', '');
        aux = aux.replace('.', '');
        aux = aux.replace(',', '.');

        if (!product.id) {
          data.id = uuid();
        } else {
          data.id = produto?.id;
        }

        // data.id = produto ? produto.id : 0;
        data.valor = aux;
        data.imagem = img ? img : product?.id ? produto.imagem : null;
        data.grupos = product?.id ? produto.grupos : [];
        data.url_imagem = product?.url_imagem ? produto.url_imagem : '';
        data.remove_azure = produto ? produto.remove_azure : false;
        data.ativo = 'S';

        const {
          id,
          cod_barras,
          nome,
          classif,
          descricao,
          valor,
          imagem,
          url_imagem,
          grupos,
          remove_azure,
          venda_delivery,
          venda_local,
          destaque_delivery,
          destaque_local,
          sku,
          ativo,
        } = data;

        const auxProduto = {
          id,
          cod_barras,
          nome,
          classif,
          descricao,
          valor: parseFloat(valor),
          imagem,
          url_imagem,
          grupos,
          remove_azure,
          venda_delivery,
          venda_local,
          destaque_delivery,
          destaque_local,
          sku,
          ativo,
        };

        setHookProduto(auxProduto);

        if (product?.id) {
          setRadioComp(produto?.grupos?.length > 0 ? 'S' : 'N');
        }

        setTabIndex(1);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [product, produto, img, setHookProduto],
  );

  const handlePesquisa = useCallback(() => {
    const texto = formRefGrupoComp.current?.getFieldValue('produto');

    if (texto === '' || texto === ' ') {
      setPesquisa([]);
      setProdutosVisibles(false);
      return;
    }

    setProdutosVisibles(true);
    const searchKeys = ['nome', 'cod_barras'];
    const results = search(produtos, searchKeys, texto);

    setPesquisa(results);
    setProdutosVisibles(results.length > 0 ? true : false);
  }, [produtos]);

  const handleProdutoSelected = useCallback(
    async (data: any) => {
      try {
        formRefGrupoComp.current?.setErrors({});

        const schema = Yup.object().shape({
          produto: Yup.string().required('Produto é obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        api
          .post('cardapio/portal/grupo', {
            emp: company.id,
            cod: productSelect.cod_barras,
          })
          .then(response => {
            const auxGrupos = produto?.grupos;

            if (response.data.length > 0) {
              response.data.map((item: GrupoData) => {
                item.id = uuid();
                auxGrupos.push(item);
                return item;
              });
            } else {
              addToast({
                type: 'info',
                title: 'Produto sem Complementos!',
                description:
                  'O Produto selecionado não possue grupo de complementos.',
              });
            }

            formRefGrupoComp.current?.reset();
            setProdutoSelect({} as ProdutoData);
            setCopyGroup(false);
          })
          .catch(err => {
            if (
              err &&
              err.response &&
              err.response.data &&
              err.response.data.signin
            ) {
              signOut();
              addToast({
                type: 'info',
                title: 'Login',
                description:
                  'Seu login expirou, faça o login novamente para a sua segurança.',
              });
            }
          });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefGrupoComp.current?.setErrors(errors);
        }
      }
    },
    [company, productSelect, addToast, produto, signOut],
  );

  const handleCancel = useCallback(() => {
    const r = window.confirm(
      'Você não salvou suas alterações!\nDeseja sair sem salvar?',
    );

    if (r) {
      formRef.current?.reset();
      resetHookProduto();
      setVisible(false);
      onClose();
    }
  }, [onClose, resetHookProduto]);

  const handleSubmitCadastro = useCallback(async () => {
    setLoading(true);
    const data = new FormData();

    if (img) {
      // (produto.imagem && produto.imagem !== true) {
      data.append('imagem', produto.imagem);
    }
    data.append('produto', JSON.stringify(produto));

    await api
      .post('portal/produto/store/create', data, {
        headers: {
          type_picture: '',
        },
      })
      .then(async response => {
        if (response.data.che === 'S') {
          if (product?.id) {
            const indexProd = produtos.findIndex(
              item => item.id === product?.id,
            );
            produtos[indexProd] = response.data.produto;
          } else {
            produtos.push(response.data.produto);
          }

          addToast({
            type: 'success',
            title: 'Cadastro de Produto',
            description: `${response.data.men}`,
          });

          formRef.current?.reset();
          resetHookProduto();
          onClose();
        } else {
          addToast({
            type: 'error',
            title: 'Cadastro de Produto',
            description: `${response.data.men}`,
          });
        }
      })
      .catch(() => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    produto,
    img,
    addToast,
    resetHookProduto,
    onClose,
    setLoading,
    produtos,
    product,
  ]);

  return (
    <Container id="ModalProduto">
      <Content className={`${visible ? 'active' : ''}`}>
				<Header>
					<h1>{product?.nome ? product.nome : 'Novo Item'}</h1>
				</Header>

				<TabsView>
					<Tabs className="tabs" index={tabIndex}>
						<TabList className="tab-list">
							<Tab className="tab" onClick={() => setTabIndex(0)}>
								Detalhes
							</Tab>
							
							<Tab
								className="tab"
								onClick={() => setTabIndex(produto?.cod_barras ? 1 : 0)}
							>
								Complemento
							</Tab>
						</TabList>

						<TabPanels className="tab-panels">
							<TabProduto className="tab-panel">
								<FormViewDetalhes ref={formRef} onSubmit={handleSubmit}>
									<div className="form-left">
										{/* COD_BARRAS */}
										<div className="input">
											<p>Código do item <span>(obrigatório)</span></p>

											<Input
												name="cod_barras"
												type="text"
												placeholder="Código do Item"
												containerStyle={{ padding: '5px 10px' }}
											/>
										</div>

										{/* SKU */}
										<div className="input">
											<p>Código SKU <span>(obrigatório)</span></p>

											<Input
												name="sku"
												type="text"
												placeholder="Código SKU"
												containerStyle={{ padding: '5px 10px' }}
											/>
										</div>
										
										{/* CLASSIFICAÇÃO */ }
										< div className="input">
											<p>Classificação <span>(obrigatório)</span></p>

											{loading ? (
												<Spinner color="blue.500" mt={1} />
											) : (
												<InputSelectClassif
													name="classif"
													placeholder="Classificação"
													options={classificacoes}
													defaultValue={classificacao.id_sub ? classificacao?.id_sub : ''}
													containerStyle={{ padding: '5px 10px' }}
												/>
										)}
										</div>

										{/* NOME */}
										<div className="input">
											<p>
												Nome do item <span>(obrigatório)</span>
											</p>
											<Input
												name="nome"
												type="text"
												placeholder="Nome"
												containerStyle={{ padding: '5px 10px' }}
											/>
										</div>

										{/* DESCRIÇÃO */}
										<div className="input">
											<p>
												Descrição <span>(obrigatório)</span>
											</p>
											<InputTextArea
												name="descricao"
												placeholder="Descrição"
												rows={3}
												cols={5}
												max={5000}
												onChange={handleDescriptionLength}
												containerStyle={{ padding: '5px 10px' }}
											/>

											<span>
												{descriptionLength ? descriptionLength : 0}/5000
												caracteres
											</span>
										</div>

										{/* PREÇO */}
										<div className="input">
											<p>
												Preço <span>(obrigatório)</span>
											</p>
											<Input
												name="valor"
												type="text"
												placeholder="Preço"
												onChange={handleMoeda}
												containerStyle={{ padding: '5px 10px' }}
											/>
										</div>

										{/* CHECKBOX DELIVERY */}
										<div className="input">
											<p>Delivery</p>
											<InputCheckbox
												name="venda_delivery"
												placeholder="Venda Delivery"
												defaultChecked={true}
												containerStyle={{ padding: '10px 0 0 10px' }}
											/>
											<InputCheckbox
												name="destaque_delivery"
												placeholder="Destaque Delivery"
												containerStyle={{ padding: '10px 0 0 10px' }}
											/>
										</div>

										{/* CHECKBOX LOCAL */}
										<div className="input">
											<p>Local</p>
											<InputCheckbox
												name="venda_local"
												placeholder="Venda Local"
												defaultChecked={true}
												containerStyle={{ padding: '10px 0 0 10px' }}
											/>
											<InputCheckbox
												name="destaque_local"
												placeholder="Destaque Local"
												containerStyle={{ padding: '10px 0 0 10px' }}
											/>
										</div>
									</div>

									<div className="form-right">
										<p>Imagem do item</p>
										<span>Aparece no cardápio e nos detalhes.</span>

										<ImgInput>
											<img
												src={
													fotoUrl
														? fotoUrl
														: // : product?.id
														// ? product.url_imagem
														'https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png'
												}
												alt="Imagem Produto"
											/>

											<label className="select-picture" htmlFor="imagem">
												<FiCamera />

												<input
													type="file"
													id="imagem"
													name="imagem"
													onChange={handleImagemChange}
												/>
											</label>

											{
												// img || product?.url_imagem ? (
												fotoUrl ? (
													<label
														className="remove-picture"
														onClick={handleRemoveImg}
													>
														<FiX />
													</label>
												) : null
											}
										</ImgInput>

										<div className="dados-imagem">
											<span>Formatos:</span>&nbsp;<p>JPEG, JPG, PNG</p>
										</div>
										<div className="dados-imagem">
											<span>Tamanho máximo:</span>&nbsp;<p>4 MB</p>
										</div>
									</div>

									<Buttons>
										<button
											type="button"
											className="button-cancel"
											onClick={handleCancel}
										>
											Cancelar
										</button>
										<button type="submit" className="button-save">
											Próximo
										</button>
									</Buttons>
								</FormViewDetalhes>
							</TabProduto>

							<TabComplemento className="tab-panel">
								<div className="tab-content">
									<Header>
										<h1>Complementos</h1>
										<h2>
											Adicione aqui complementos para seu produto ficar ainda
											mais atrativo.
										</h2>
									</Header>

									<SelectedYesNo>
										<h1>Selecione uma opção</h1>

										<div className="radio-group">
											<div className="radio">
												<div
													className="radio-label"
													onClick={() =>
														(!produto ||
															!produto.grupos ||
															produto?.grupos?.length === 0) &&
														setRadioComp('N')
													}
												>
													<input
														type="radio"
														value="N"
														checked={radioComp === 'N'}
														onChange={() => setRadioComp('N')}
														disabled={produto?.grupos?.length > 0}
													/>
													<label>Não, este item não possue complemento.</label>
												</div>
											</div>
											<div className="radio">
												<div
													className="radio-label"
													onClick={() => setRadioComp('S')}
												>
													<input
														type="radio"
														value="S"
														checked={radioComp === 'S'}
														onChange={() => setRadioComp('S')}
													/>
													<label>Sim, este item possue complemento.</label>
												</div>
											</div>
										</div>
									</SelectedYesNo>

									{produto?.grupos?.length > 0 && (
										<GruposList>
											<header className="header-grupos">
												Grupos de complementos que compõem este produto
											</header>

											{produto.grupos.map((grupo, indice) => (
												<Grupo key={indice}>
													<Accordion
														className="accordion"
														allowToggle
														defaultIndex={[0]}
													>
														<AccordionItem className="accordion-item">
															<div className="header-grupo">
																<div className="name-grupo">
																	<h1>{grupo.nome}</h1>
																	<h2>{`${grupo.complementos.length} opções`}</h2>
																</div>

																<div className="buttons-grupo">
																	<span>
																		{grupo.obrigatorio === 'S'
																			? 'Obrigatório'
																			: 'Opcional'}
																	</span>

																	<Menu>
																		{({ isOpen }) => (
																			<>
																				<MenuButton
																					className="menu-button"
																					as={IconButton}
																					isActive={isOpen}
																					aria-label="Options"
																					icon={<FiMoreVertical />}
																					variant="outline"
																				/>

																				<MenuList className="menu-list">
																					<MenuItem
																						className="item"
																						onClick={() => {
																							setGrupoModal(grupo);
																							setModalGrupoCompVisible(true);
																						}}
																					>
																						Editar
																					</MenuItem>

																					<MenuItem
																						className="item"
																						onClick={() =>
																							removeHookGrupo(grupo)
																						}
																					>
																						Excluir
																					</MenuItem>
																				</MenuList>
																			</>
																		)}
																	</Menu>

																	<AccordionButton className="accordion-button">
																		<AccordionIcon />
																	</AccordionButton>
																</div>
															</div>

															<hr />

															<AccordionPanel
																className="accordion-panel"
																pb={4}
															>
																<ComplementosList>
																	{grupo.complementos?.map((comp, indicee) => (
																		<Complemento key={indicee}>
																			<div className="name-description">
																				<h1>{comp.nome}</h1>
																				<h2>{comp.descricao}</h2>
																				<h3>
																					min: {comp.qtd_gratis} - max:{' '}
																					{comp.qtd_maxima}
																				</h3>
																			</div>

																			<h2>{formatPrice(comp.valor)}</h2>
																		</Complemento>
																	))}
																</ComplementosList>
															</AccordionPanel>
														</AccordionItem>
													</Accordion>
												</Grupo>
											))}
										</GruposList>
									)}

									{radioComp === 'S' && (
										<ButtonsComp>
											<button
												disabled={copyGroup}
												onClick={() => {
													setGrupoModal({} as GrupoData);
													setModalGrupoCompVisible(true);
												}}
											>
												+ Criar grupo de complementos
											</button>
											<button onClick={() => setCopyGroup(!copyGroup)}>
												Copiar de outro item
											</button>
										</ButtonsComp>
									)}

									{copyGroup && (
										<AddGrupoComplementos>
											<header>
												<h1>Copiar Grupo Existente</h1>

												<button onClick={() => setCopyGroup(false)}>
													Cancelar
												</button>
											</header>

											<FormViewGrupoComp
												ref={formRefGrupoComp}
												onSubmit={handleProdutoSelected}
											>
												<div className="input">
													<p>
														Código/Nome Produto{' '}
														<span className="span-p">(obrigatório)</span>
													</p>
													<Input
														name="produto"
														type="text"
														placeholder="Código ou nome do Produto"
														containerStyle={{ padding: '5px 10px' }}
														onChange={() => handlePesquisa()}
														onBlur={() => {
															setTimeout(() => {
																setProdutosVisibles(false);
															}, 200);
														}}
													/>

													{produtosVisibles && (
														<div className="pesquisa-produto">
															{pesquisa.map((item, indice) => (
																<div
																	className="pesquisa-item"
																	key={indice}
																	onClick={() => {
																		setProdutoSelect(item);
																		formRefGrupoComp.current?.setFieldValue(
																			'produto',
																			item.nome,
																		);
																	}}
																>
																	<span>{item.nome}</span>
																</div>
															))}
														</div>
													)}
												</div>

												<button
													className="button-confirm"
													disabled={!productSelect.id}
												>
													Confirmar
												</button>
											</FormViewGrupoComp>
										</AddGrupoComplementos>
									)}

									<Buttons>
										<button
											type="button"
											className="button-cancel"
											onClick={handleCancel}
										>
											Cancelar
										</button>
										<button
											type="button"
											className="button-save"
											disabled={
												radioComp === 'S' && produto?.grupos?.length === 0
													? true
													: false
											}
											onClick={handleSubmitCadastro}
										>
											Salvar
										</button>
									</Buttons>
								</div>
							</TabComplemento>
						</TabPanels>
					</Tabs>
				</TabsView>
      </Content>
    </Container>
  );
};

export default ModalProduto;
